<template>
  <div>
    <div class="navbar-fixed">
      <nav>
        <div class="nav-wrapper">
          <router-link class="brand-logo" :to="{name: 'HomePage'}" exact>
            <img src="/Logo.png" alt="Logo" class="responsive-img logo" height="32px" width="32px" />
          </router-link>
          <!-- <a href="#" class="brand-logo"> -->
          <!-- </a> -->
          <a href="#" data-target="mobile-demo" class="sidenav-trigger">
            <i class="material-icons">menu</i>
          </a>
          <ul class="right hide-on-med-and-down">
            <li class="pure-menu-item pure-menu-selected">
              <router-link
                class="pure-menu-item pure-menu-selected"
                :to="{name: 'HomePage'}"
                exact
              >Home</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="{name: 'AllProjectsPage'}" exact>Projects</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="{name: 'ExperiencePage'}" exact>Experience</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="{name: 'OtherHomePage'}" exact>Other Home</router-link>
            </li>
          </ul>
        </div>
      </nav>

      <ul class="sidenav" id="mobile-demo">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#proj">Projects</a>
        </li>
        <li>
          <a href="#abt">About</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  name: "NavComponent",
  mounted() {}
};
</script>

<style>
</style>
